import React from 'react';
import { FaHardHat, FaBuilding, FaTools } from 'react-icons/fa';

const Construction = () => {
  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-4xl font-bold mb-6 text-center text-blue-600">Servicios de Construcción</h1>

      <div className="grid md:grid-cols-2 gap-8 items-center mb-12">
        <div>
          <h2 className="text-2xl font-semibold mb-4">Construimos tus sueños</h2>
          <p className="text-gray-700 mb-4">
            Nuestro equipo de expertos en construcción está listo para llevar a cabo proyectos de cualquier escala. 
            Desde casas unifamiliares hasta complejos comerciales, aplicamos las últimas técnicas y tecnologías 
            para garantizar estructuras duraderas y eficientes.
          </p>
          <ul className="list-disc list-inside text-gray-700">
            <li>Construcción residencial y comercial</li>
            <li>Gestión integral de proyectos</li>
            <li>Cumplimiento de normativas y regulaciones</li>
            <li>Uso de materiales sostenibles</li>
          </ul>
        </div>
        <div className="flex justify-center">
          <FaBuilding className="text-blue-500 w-64 h-64" />
        </div>
      </div>

      <div className="bg-gray-100 p-8 rounded-lg shadow-md">
        <h3 className="text-xl font-semibold mb-4">Nuestro proceso de construcción</h3>
        <div className="grid md:grid-cols-3 gap-6">
          <div className="text-center">
            <FaHardHat className="mx-auto text-blue-500 w-12 h-12 mb-2" />
            <h4 className="font-semibold mb-2">Planificación</h4>
            <p className="text-sm text-gray-600">Diseño detallado y obtención de permisos</p>
          </div>
          <div className="text-center">
            <FaTools className="mx-auto text-blue-500 w-12 h-12 mb-2" />
            <h4 className="font-semibold mb-2">Construcción</h4>
            <p className="text-sm text-gray-600">Ejecución precisa y control de calidad</p>
          </div>
          <div className="text-center">
            <FaBuilding className="mx-auto text-blue-500 w-12 h-12 mb-2" />
            <h4 className="font-semibold mb-2">Finalización</h4>
            <p className="text-sm text-gray-600">Inspecciones finales y entrega del proyecto</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Construction;